module.exports = __webpack_public_path__ + "img/login_bg.72c19b17.png";